import { PLATFORM } from '~constants/environment';

const EXCEPTION_EVENT = 'exception';
const MAX_DESCRIPTION_LENGTH = 500;

// There is no error tracker (e.g. Sentry) in this project yet, so errors are sent to GTM as a
// GA4 "exception" event. If a tracker is added, it should be called from here
export const logError = (error, context = {}) => {
  // eslint-disable-next-line no-console
  console.error(error, context);

  if (!window.dataLayer) {
    return;
  }

  window.dataLayer.push({
    event: EXCEPTION_EVENT,
    description: `${error?.name}: ${error?.message}`.slice(0, MAX_DESCRIPTION_LENGTH),
    fatal: true,
    platform: PLATFORM,
    ...context,
    componentStack: context.componentStack?.slice(0, MAX_DESCRIPTION_LENGTH)
  });
};
